import extendedFieldHooks from "ExtendedFields/selectorHooks";
import FnrTypography from "FnrTypography/FnrTypography";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

const EditSelector = () => {
  const [id, setId] = extendedFieldHooks.useEditPermissionId();
  const [viewId] = extendedFieldHooks.useViewPermissionId();
  const isSuperAdmin = extendedFieldHooks.useIsSuperAdmin();

  const handleSetUser = () => {
    const newId = id === 1 ? 2 : 1;
    setId(newId);
  };

  const handleSetAdmin = () => {
    const newId = id <= 2 ? 3 : 2;
    setId(newId);
  };

  return (
    <FnrVerticalGap gap={8}>
      <FnrTypography>
        Who can{" "}
        <strong>
          <em>edit</em>
        </strong>{" "}
        this field?
      </FnrTypography>
      <FnrHorizontalGap gap={32}>
        <FnrCheckbox
          on={id < 2}
          toggleOn={handleSetUser}
          data-cy="PrivilegeLevel_UserEdit"
          disabled={viewId > 1 || id > 2}
        >
          <span>The User</span>
        </FnrCheckbox>
        <FnrCheckbox
          on={id < 3}
          toggleOn={handleSetAdmin}
          data-cy="PrivilegeLevel_AdminEdit"
          disabled={viewId > 2 || !isSuperAdmin}
        >
          <span>Group Admins</span>
        </FnrCheckbox>
      </FnrHorizontalGap>
    </FnrVerticalGap>
  );
};

export default EditSelector;
